<template>
  <div class="fav-services-page">
    <div class="page-header">
      <h1>Ulubione usługi</h1>
    </div>

    <ServiceModal />

    <section class="section-card" v-if="currentUser && favServices.length > 0">
      <div class="section-card-header">
        <h2>Twoja lista usług</h2>
      </div>

      <div class="services-grid">
        <ServiceCardVue
            v-for="service in favServices"
            :key="service.id"
            :id="service.itemId"
            :fav="true"
            :is-advance="service.advanceAmount ? true : false"
            :price="service.price"
            :img="service.photo_url"
            :name="service.name"
            :state="service.state_name"
            :ishighlighted="service.active"
            :should-show-action-button="true"
            @deleteFavService="(id) => deleteFavService(id)"
            @openServiceModal="() => $router.push({ path: '/profile/fav-services', query: { serviceID: service.id } })"
        />
      </div>
    </section>

    <section class="section-card" v-else>
      <div class="empty-state">
        <p>Brak ulubionych usług.</p>
      </div>
    </section>
  </div>
</template>

<script>
import axios from 'axios';
import { useMeta } from 'vue-meta';
import ServiceCardVue from '@/components/SpecialComponents/ServiceCard.vue';
import ServiceModal from '@/components/SpecialComponents/ServiceModal.vue';
import authHeader from '@/services/auth-header';
import { useAuthStore } from '@/stores/auth';

export default {
  name: 'PrivProfileFavServices',
  setup() {
    useMeta({ title: 'Ulubione usługi' });

    return {
      authStore: useAuthStore()
    };
  },
  data() {
    return {
      favServices: []
    };
  },
  computed: {
    currentUser() {
      return this.authStore.user;
    }
  },
  mounted() {
    if (!this.currentUser) {
      this.$router.push('/login');
    } else if (this.currentUser.role_id !== 3) {
      this.$router.push('/login');
    }
    this.getFavServices();
  },
  methods: {
    getFavServices() {
      this.favServices = [];
      axios.get(`/UserService/${this.currentUser.id}`)
          .then((res) => {
            res.data.forEach((item) => {
              if (item.service) {
                item.service.itemId = item.id;
                this.favServices.push(item.service);
              }
            });

            axios.get('/State').then((stateRes) => {
              this.favServices.forEach((service) => {
                const state = stateRes.data.find((x) => x.id == service.state_id);
                service.state_name = state ? state.name : '';
              });
            });
          });
    },
    deleteFavService(id) {
      axios.delete(`/UserService/${id}`, authHeader()).then(() => {
        this.favServices = this.favServices.filter((serv) => serv.itemId !== id);
      });
    }
  },
  components: {
    ServiceCardVue,
    ServiceModal
  }
};
</script>

<style scoped lang="scss">
.fav-services-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 32px 16px;
  font-family: sans-serif;
  box-sizing: border-box;
}

.page-header {
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 2px solid #e5e7eb;
}

.page-header h1 {
  margin: 0;
  font-size: 2.8rem;
  color: #1f2937;
  font-weight: 700;
}

.section-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, .08);
  padding: 24px;
  margin-bottom: 20px;
  box-sizing: border-box;
}

.section-card-header h2 {
  margin: 0 0 16px 0;
  font-size: 2rem;
  color: #1f2937;
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 20px;
  align-items: stretch;
}

.empty-state {
  text-align: center;
  color: #9ca3af;
  font-size: 1.5rem;
  border: 1px dashed #d1d5db;
  border-radius: 10px;
  padding: 24px;
}

@media (max-width: 1024px) {
  .services-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 720px) {
  .services-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 480px) {
  .fav-services-page {
    padding: 16px 12px;
  }

  .page-header h1 {
    font-size: 2.2rem;
  }

  .section-card {
    padding: 16px 12px;
    border-radius: 8px;
  }

  .section-card-header h2 {
    font-size: 1.8rem;
  }
}
</style>